import { of, OperatorFunction, Observable, combineLatest, isObservable } from "rxjs";
import { switchMap, map } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";


export function NgxMultiTimeline(startDate: Date | Observable<Date>, endDate: Date | Observable<Date>, interval: String | Observable<String> ): OperatorFunction<Multi[], Multi[]> {

  return switchMap(multis =>
    combineLatest(
      isObservable(startDate) ? startDate : of(startDate),
      isObservable(endDate) ? endDate : of(endDate),
      isObservable(interval) ? interval : of(interval)
    ).pipe(
      map(([
        _startDate,
        _endDate,
        _interval
      ]) => {

        if (_startDate == null || _endDate == null) {
          const values = multis.map(m => m.series.map(m => m.name)).flat();
          if (values.length == 0) return [];

          if (_startDate == null) {
            _startDate = new Date(Math.min(...values));
            if (_interval == "DAYS") _startDate.setHours(0);

          }
          if (_endDate == null) {
            _endDate = new Date(Math.max(...values));
            if (_interval == "DAYS") _endDate.setHours(0);
          }
        }

        let currentDate = new Date(_startDate.getTime());
        let dataPoints: Date[] = [];
        
        while (currentDate <= _endDate) {
          dataPoints.push(currentDate);

          if (_interval == "HOURS") currentDate = new Date(currentDate.getTime() + 3600000);
          else if (_interval == "DAYS") {
            currentDate = new Date(currentDate.getTime());
            currentDate.setDate(currentDate.getDate() + 1);
          }
        }




        const newMultis = multis.map(multi => {

          const groupBy = multi.series.groupBy(s => {
            if (_interval == "DAYS") s.name.setHours(0); //hack to fix grouping by day issue
            return s.name;
          });

          const newSeries = dataPoints.map(dataPoint => {
            const single = groupBy[dataPoint as any];

            return single != null ? single[0] : {
              name: dataPoint,
              value: 0
            }
          });
          //multi.forEach(a => a)


          return Object.assign({}, multi, { series: newSeries });

        });

        return newMultis;
      })
    )
  );

}

